import React from 'react';
import {ISelectProps,  SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {TableSortDirection} from '~/components/Table';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {sortByString} from '~/lib/sort';
import {fetchChargeSchemas} from '~/modules/Clients/api';

type ISelectSellerProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectChargeSchema = ({
    disabled,
    ...props
}: ISelectSellerProps) => {
    const {resource, isPending} = useResource(() => fetchChargeSchemas(), []);
    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && !disabled && <i className='fa fa-spinner fa-spin'/>}
        items={sortByString(resource, 'label', TableSortDirection.ASC)}/>;
};

export const SelectChargeSchemaField = (props: IFieldProps<ISelectSellerProps>) => <FormField {...props}>
    <SelectChargeSchema {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
